$(document).ready(function () {
//  mega menu start
  if ($('.mega__link').hasClass('mega-menu__link--active')) {
    $('#image-all').css('display', 'none');
  } else {
    $('#image-all').css('display', 'block');
  }
 
$('.product-effects-list').wrapAll('<div class="pro-effects-wrapper"></div>');
 
$(window).on('load', function () {
  if ($(window).width() >= 890) {
    // STEP 1: Reset all
    $('.mega-menu-set').removeClass('active');
    $('.menu_image-wrap').css('display', 'none').removeClass('active-img');
 
    // STEP 2: Activate first menu item
    var $firstItem = $('.mega-menu-set').first();
    $firstItem.addClass('active');
 
    // STEP 3: Show corresponding image
    var firstAttr = $firstItem.attr('data-menu');
    $('#image-' + firstAttr).css('display', 'block').addClass('active-img');
 
    // STEP 4: Hover behavior for all menu items
    $('.mega-menu-set').hover(function () {
      // Reset everything
      $('.mega-menu-set').removeClass('active');
      $('.menu_image-wrap').css('display', 'none').removeClass('active-img');
 
      // Activate hovered item
      $(this).addClass('active');
      var hoverAttr = $(this).attr('data-menu');
      $('#image-' + hoverAttr).css('display', 'block').addClass('active-img');
    });
  }
});
 
// mega menu end
 
 
  //  homepage banner start 
if($('.slideshow-banner').length > 0){
  $('.slideshow-cstm').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:true,
    speed: 500,
    vertical: true,
    verticalSwiping: true,
    arrows:false,
    dots: true,
    responsive: [
       {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
         verticalSwiping: false,
        }
      }
    ]
  });
}
 
//  homepage banner end
 
      
  // featured product slider js start
if($('.product-slider').length > 0){
  $('.product-carousel').slick({
      infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
    arrows:true,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll:1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
 
   $('.responsive').slick({
  dots: false,
  infinite: true,
  speed: 300,
    slidesToShow: 4,
    slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    }
 
  ]
});
}
 
 
  //  featured product slider end
// ----------------- popup video section --------------     
  $('.product-grids-items .main-product-card.video_popup_wrapper' ).on( "click", function() {
        var id_attr = $(this).attr('data-id');
        var images1 = $('#img-'+id_attr).html();
        $('#show_img2').html(images1);
     $("body").addClass('active');
      $(".custom-model-main").addClass('model-open');
    $("#show_img2 .custom_inner_wrapper .popup_video_inner video").trigger("play");
    });
    $(".close-btn.data.close-btn").click(function(){
    $(".custom-model-main").removeClass('model-open');
      $("body").removeClass('active');
      $("#show_img2 .custom_inner_wrapper .popup_video_inner video").trigger("pause");
      $(".custom_inner_wrapper .popup_video_inner video").get(0).currentTime = 0;
});
  // product slider js end
 
 
   // -----------custom faq's ------------
 
  $(".accordion_tab .blinking-icons-wrapper .heading-accordion").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".accordion_tab .blinking-icons-wrapper .content-accordion").slideUp(500);
    } else {
      $(".accordion_tab .blinking-icons-wrapper .heading-accordion").removeClass("active");
      $(this).addClass("active");
      $(".accordion_tab .blinking-icons-wrapper .main-accordion .content-accordion").slideUp(500);
      $(this).siblings(".accordion_tab .blinking-icons-wrapper .content-accordion").slideDown(500);
    }
  });
//   -----------custom faq's  ------------
 
// Collection-list
  if($('.collection-list').hasClass('grid--2-col-desktop')){
    $('.slide_1, .slide_2, .slide_3, .slide_4').wrapAll("<div class='collection-list-left'></div>"); 
  }
 
 
// new start
$(".custom_cart_section .product-form_cart").click(function(){
  $('.sticky-bottom-price .quantity__input').val('1');
  $( ".product__info-container .product-form__submit.button.button--full-width.button--secondary" ).trigger( "click" );
var pdp_update_price = $('.display_none_varients .variants-data.active').attr("main_price");
   $('.productPriceContainer .symbol-amount').text(pdp_update_price);
});
 
  
  $(".sticky-bottom-price .price-per-item__container .quantity__button[name='plus']").click(function(){
    $( ".product__info-container .price-per-item__container button.quantity__button[name='plus']" ).trigger( "click" );    
  });
  $(".sticky-bottom-price .price-per-item__container .quantity__button[name='minus']").click(function(){
    $( ".product__info-container .price-per-item__container button.quantity__button[name='minus']" ).trigger( "click" ); 
  });
// update price here start
$(document).on("click", ".price-per-item__container .quantity__button", function () {
  // Get current quantity
  const $quantityWrapper = $(this).closest("quantity-input");
  const $quantityInput = $quantityWrapper.find(".quantity__input");
  let quantity = parseInt($quantityInput.val());

  // Get raw price (replace comma and convert to float)
  let rawPrice = $(".symbol-amount").attr("data-price");
  if (!rawPrice) return;

  let unitPrice = parseFloat(rawPrice.replace(',', '.')); // Convert to 55.00

  // Adjust quantity based on button clicked
  const action = $(this).attr("name");


  // Update quantity input value
  $quantityInput.val(quantity);

  // Calculate new total price
  const totalPrice = (unitPrice * quantity).toFixed(2); // keep 2 decimals

  // Update visible price
  $(".symbol-amount").text(totalPrice);
});

  // update price here end
 
// ---------sticky varieant -------------
   $(".sticky-bottom-price .sticky-bottom-inner .size-varient").click(function () {
  $(this).toggleClass('active-size');
  });
   $(".sticky-bottom-price .sticky-bottom-inner ul#size-variant .input-var-size .list-title").click(function () {   
     var data2 = $(this).attr('main_value_name');
    $('.main-pdp-varients .radio-input.'+data2).trigger('click');
});
  // new end
  // -------------on load symbol  -------------
  var logo_text = $('.no-js-hidden.pdp_price_wrapper').attr('pdp_logo');
  var symbol = logo_text;
  $('.custom_price.productPriceContainer.inc-quantity .symbol-logo').text(symbol);
  $(".sticky-bottom-price .price-per-item__container .quantity__button").click(function(){
    var text = $('.display_none_varients .variants-data.active').attr("main_price");
    var str1 = text;
    var str2 = ",";
    if(str1.indexOf(str2) != -1){
      var text_2 = text.replace(',', '');
    }
    else{var text_2 = text;}
    var pdp_price = parseFloat(text_2);
    var data_input = $('.sticky-bottom-price input.quantity__input').val();
    var data_type = parseFloat(data_input);
    var total_price_update=((pdp_price*data_type).toFixed(2));
    $('.productPriceContainer .symbol-amount').text(total_price_update);
  });
  
 
 
  
// ------------product color variant onload --------
 
var title_main = $('.product .main-pdp-varients .swatch-btns input:checked+label').attr('title_main');
  $('.size-varient .size-wrap-title .size-wrap-inner').text(title_main);
 
  
var active_varient_id = $('input.product-variant-id').attr('value');
  $('.display_none_varients .variants-data[variant_id='+active_varient_id +']' ).addClass('active');
var color_title = $('.main-wrapper-outer .toggle-with-media.variant-title').attr('value_name');
var bg_var_color = $('.main-wrapper-outer .toggle-with-media.variant-title').attr('value_bg_url');
   $('.varaint-pdp-slide .main-wrap-colors .color-name').css('background-image', 'url(' + bg_var_color + ')');
  $('.varaint-pdp-slide .main-wrap-colors .title-varient-name').text(color_title);
 
  var color_main_title = $('.main-wrapper-outer .toggle-with-media.variant-title').attr('value_name');
$('.line-item-property__field input#rad-slaves1').attr('value', color_main_title);
  // ------end ----------
var v_title = $('.product .main-pdp-varients .swatch-btns input:checked').attr('value_name');
// var variant_title= $('ul#cars li.input-var-color[variant_name='+v_title+']').attr('variant_title');
// var bg_color = $('ul#cars li.input-var-color[variant_name='+v_title+']').attr('bg-color');
 
// $('ul#cars li.input-var-color' ).removeClass('color-active');
//   $('ul#cars li.input-var-color[variant_name='+v_title+']' ).addClass('color-active');
  var imge_url =$('li.input-var-color.color-active').attr('data-img');
  $('.product_main_imagess .image_pdp_img').each(function (index) {
    var img_each_url = $(this).attr('data_url');
    if(img_each_url == imge_url){
      var data_tag_num = $(this).attr('aria-describedby')
      $('.product .cstm_img_new ul.slick-dots li #'+data_tag_num).trigger('click');
    }
  })


// variant 


  
 //  Blog page sort
    $('#sort-by').change(function() {
      var sortBy = $(this).val();
      var $activeTabPane = $('.blog-articles');
   if (sortBy === 'new-old') {
     // Do nothing, as it's already sorted by default
   } 
       else if (sortBy === 'old-new') {
          // Sort by data-date, old to new
          $activeTabPane.find('ul li').sort(function(a, b) {
              var dateA = $(a).data('date');
              var dateB = $(b).data('date');
              return new Date(dateA) - new Date(dateB);
          }).appendTo($activeTabPane.find('ul'));
      } else if (sortBy === 'a-z') {
          // Sort by data-title, A-Z
          $activeTabPane.find('ul li').sort(function(a, b) {
              var titleA = $(a).data('title').toUpperCase();
              var titleB = $(b).data('title').toUpperCase();
              return (titleA < titleB) ? -1 : (titleA > titleB) ? 1 : 0;
          }).appendTo($activeTabPane.find('ul'));
      } else if (sortBy === 'z-a') {
          // Sort by data-title, Z-A
          $activeTabPane.find('ul li').sort(function(a, b) {
              var titleA = $(a).data('title').toUpperCase();
              var titleB = $(b).data('title').toUpperCase();
              return (titleB < titleA) ? -1 : (titleB > titleA) ? 1 : 0;
          }).appendTo($activeTabPane.find('ul'));
      }
  });

// blog page sort end 

  //  Single blog page
if($('.single-blog-post-sec').length > 0){
  $('.related_product_slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows:true
  });
}

// Related Articles
if($('.related-part').length > 0){
  $('.related-article').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:true,
  infinite: false,
  speed: 300,
  responsive: [
    {
      breakpoint: 1281,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll:1
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});
}

 function checkFooterVisibility() {
      var footer = $('footer.footer.color-scheme-2.gradient.section-sections--25742628553047__footer-padding');
      if (!footer.length) return;

      var windowBottom = $(window).scrollTop() + $(window).height();
      var footerTop = footer.offset().top;

      if (windowBottom >= footerTop) {
        $('body').addClass('footer-stable');
      } else {
        $('body').removeClass('footer-stable');
      }
    }

    $(window).on('scroll resize load', function () {
      checkFooterVisibility();
    });

  $('.remove_btn-wrap.new').click(function () {
      $('.tutorial-filter').toggle();
    });
  $('.remove_btn-wrap.new').on('click', function () {
  $(this).toggleClass('active');
});

  // mobile filter start
   $('.tab-filter-div.facets__summary.mobile').on('click', function () {
    const $target = $('.by-price-wrapper.mobbile');
    
    if ($target.hasClass('active')) {
      $target.removeClass('active');
    } else {
      $target.addClass('active');
    }
  });
  $('.mobbile .tab-filter-div.facets__summary').on('click', function () {
    $(this).siblings('ul.fliter-price-block').toggle(); // Toggle visibility of sibling filter block
  });

  $('.mobbile li.list-menu__item.facets__item').on('click', function () {
    const $input = $(this).find('input[type="radio"]');
    $input.prop('checked', true).trigger('change');
  });

  $(' a.mobile-facets__clear.underlined-link').on('click', function () {
    $('.mobbile input[type="radio"]').prop('checked', false).trigger('change');
  });
// mobile filter end
}); 
 
 